import React, { useState, useEffect } from 'react';
import { connect } from 'react-redux';
import { getExpressParams, putExpress } from '../../../service/api';
import UserManagerMain from '../../presentation/section/admin-page/UserManagerMain';

const UserManager = (props) => {
  const [userFilter, setUserFilter] = useState('');
  const [userLabelData, setUserLabelData] = useState({
    type: null,
    name: null,
    info: [],
    nullLabelItem: [],
    nullLabelItemType: null
  })
  const [filteredArray, setFilteredArray] = useState({
    type: null,
    name: null,
    info: [],
    nullLabelItem: [],
    nullLabelItemType: null
  })
  const [selectedUser, setSelectedUser] = useState({
    bio: null,
    company: null,
    createdTime: null,
    diff: null,
    email: '',
    expireDate: null,
    fullname: '',
    madAddress: null,
    role: '',
    userID: null
  })
  const [queryLabelData, setQueryLabelData] = useState({
    type: null,
    name: null,
    owner: null,
    info: [],
    nullLabelItem: [],
    nullLabelItemType: null,
  })
  const [reportLabelData, setReportLabelData] = useState({
    type: null,
    name: null,
    info: [],
    nullLabelItem: [],
    nullLabelItemType: null,
  });
  const [snapshotLabelData, setSnapshotLabelData] = useState({
    type: null,
    name: null,
    info: [],
    nullLabelItem: [],
    nullLabelItemType: null
  });

  useEffect(() => {
    getExpressParams('/users/user-content/all',{
      email: props.currentUser
    }, (response) => {
      setUserLabelData(MakeLabelTreeData(response.data.userentity, response.data.companyentity))
    })
  },[])

  useEffect(() => {
    handleSearchBtn(JSON.stringify(userLabelData));
  },[userLabelData])

  const handleSearchInput = (event) => {
    setUserFilter(event.target.value);
  }

  const handleSearchBtn = (originArray) => {
    let tempArray = JSON.parse(originArray);
    tempArray.nullLabelItem = tempArray.nullLabelItem.filter((item)=>{
      // let compareStr = `${item.fullname} ${item.email}`
      return !userFilter
        || item.fullname.toLowerCase().startsWith(userFilter.toLowerCase())
        || item.email.toLowerCase().startsWith(userFilter.toLowerCase())
    });

    tempArray.info.forEach(
      (item) => {
        item.labelItem = item.labelItem.filter((userItem)=> {
          // let compareStr = `${userItem.fullname} ${userItem.email}`
          return !userFilter 
            || userItem.fullname.toLowerCase().startsWith(userFilter.toLowerCase())
            || userItem.email.toLowerCase().startsWith(userFilter.toLowerCase())
        });
      }
    )
    tempArray.info = tempArray.info.filter(
      ((item)=>item.labelItem.length > 0)
    );
    
    setFilteredArray(tempArray);
  }

  const handleSelectedUser = (userInfo) => {
    setSelectedUser(userInfo);
    getExpressParams('/query/query-label/userid/all', {
      email: userInfo.email
    }, (response)=>{
      setQueryLabelData(MakeLabelTreeQRSData(response.data.queryentity, response.data.BuzzLabel))
    })
    getExpressParams('/query/report-label/userid/all', {
      email: userInfo.email
    }, (response)=>{
      setReportLabelData(MakeLabelTreeQRSData(response.data.reportentity, response.data.BuzzLabel))
    })
    getExpressParams('/query/snapshot-label/userid/all', {
      email: userInfo.email
    }, (response)=>{
      setSnapshotLabelData(MakeLabelTreeQRSData(response.data.snapshotentity, response.data.BuzzLabel))
    })
  }

  const MakeLabelTreeQRSData = (nodeData, labelData) => {
    let retLabelTreeData = labelData;
    retLabelTreeData.nullLabelItemType = nodeData.type+'-QRSInfo';
    retLabelTreeData.nullLabelItem = [];
    retLabelTreeData.info.forEach((item,index)=> {
      item.labelItem = [];
      // item.checked = false;
      nodeData.info.filter((filteredNode)=>filteredNode.label==item.labelID).forEach(
        (filteredItem, index) => {
          let pushItem = filteredItem;
          // pushItem.checked = false;
          item.labelItem.push(pushItem);
          item.labelItemType = nodeData.type+'-QRSInfo';
      })
    })
    nodeData.info.filter((filteredNode) => filteredNode.label==null).forEach(
      (item)=>{
        let pushItem = item;
        // pushItem.checked = false;
        retLabelTreeData.nullLabelItem.push(pushItem);
      }
    );
    return retLabelTreeData;
  }

  const MakeLabelTreeData = (nodeData, labelData) => {
    let retLabelTreeData = labelData;
    retLabelTreeData.nullLabelItemType = nodeData.type;
    retLabelTreeData.nullLabelItem = [];
    retLabelTreeData.info.forEach((item,index)=> {
      item.labelItem = [];
      // item.checked = false;
      nodeData.info.filter((filteredNode)=>filteredNode.company==item.company).forEach(
        (filteredItem, index) => {
          let pushItem = filteredItem;
          // pushItem.checked = false;
          item.labelItem.push(pushItem);
          item.labelItemType = nodeData.type;
      })
    })
    nodeData.info.filter((filteredNode) => filteredNode.company==null).forEach(
      (item)=>{
        let pushItem = item;
        // pushItem.checked = false;
        retLabelTreeData.nullLabelItem.push(pushItem);
      }
    );
    return retLabelTreeData;
  }


  return (
    < UserManagerMain handleSelectedUser={handleSelectedUser} selectedUser={selectedUser} userLabelData={userLabelData}
    handleSearchBtn={handleSearchBtn} userFilter={userFilter} handleSearchInput={handleSearchInput} filteredArray={filteredArray}
    queryLabelData={queryLabelData} reportLabelData={reportLabelData} snapshotLabelData={snapshotLabelData}
    />
  )
}

const mapStateToProps = (state) => ({
  currentUser: state.AuthManager.status.currentUser
})
export default connect(mapStateToProps) (UserManager);